import { render, staticRenderFns } from "./IconX.vue?vue&type=template&id=725b9e5c"
import script from "./IconX.vue?vue&type=script&lang=ts"
export * from "./IconX.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports